type InfoSectionProps = {
  title: string;
  infoList: { label: string; value: string; cyTag: string }[];
};
export const InfoSection = ({ title, infoList }: InfoSectionProps) => {
  return (
    <div className="display-flex flex-col align-items-start w-full p-4 rounded-lg bg-primary-t-900 mb-4">
      <h3 className="sub-heading-sb mb-4">{title}</h3>
      <dl className="mt-2">
        {infoList.map((info, index) => (
          <div
            key={info.label}
            className={
              'flex min-w-0 flex-col gap-1 sm:flex-row sm:justify-between sm:gap-4 w-full' +
              (index < infoList.length - 1 ? ' mb-3' : '')
            }
          >
            <dt className="text-sm font-bold sm:shrink-0">{info.label}:</dt>
            <dd data-cy={info.cyTag} className="min-w-0 text-sm [overflow-wrap:anywhere]">
              {info.value}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
